import { createSelector } from 'reselect';

export const selectInfoBarMarketing = state => state.infoBarMarketing;
export const selectInfoBarMarketingConfig = createSelector(
  selectInfoBarMarketing,
  infoBarMarketing => infoBarMarketing.config,
);

export const selectInfoBarMarketingIsLoading = createSelector(
  selectInfoBarMarketing,
  infoBarMarketing => infoBarMarketing.isLoading,
);

export const selectInfoBarMarketingIsLoaded = createSelector(
  selectInfoBarMarketing,
  infoBarMarketing => infoBarMarketing.isLoaded,
);

export const selectInfoBarMarketingPlacements = createSelector(
  selectInfoBarMarketing,
  infoBarMarketing => infoBarMarketing.offers,
);

export const selectInfoBarMarketingPlacementToDisplay = createSelector(
  selectInfoBarMarketing,
  infoBarMarketing => infoBarMarketing.offers[0],
);

export const selectInfoBarMarketingResponseDate = createSelector(
  selectInfoBarMarketing,
  infoBarMarketing => infoBarMarketing.responseDate,
);
